module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Plant_16"],"path":[{"$":{"d":"M13,2V8L6,5V8L0,5v9H16V2ZM4,12H2V10H4Zm4,0H6V10H8Zm4,0H10V10h2Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Plant_16.svg
// module id = gz1A
// module chunks = 1